
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "button",
    },
    link: {
      type: [String, Object],
    },
    logo: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    button: {
      type: String,
      default: "white",
    },
    title: {
      type: String,
    },
  },
  computed: {
    buttonStyle() {
      let classes;

      if (this.button === "white") {
        classes =
          "text-primary-green-200 md:hover:text-white bg-white md:hover:bg-primary-green-200 border-transparent";
      } else if (this.button === "green") {
        classes =
          "text-white bg-primary-green-200 md:hover:bg-primary-green-300 border-transparent";
      } else
        classes =
          "text-primary-green-200 md:hover:text-white md:hover:bg-primary-green-200 border-primary-green-200";

      return classes;
    },
  },
};
